module.exports = __webpack_public_path__ + "img/bg_image_blur.1ec68237.jpg";